module.exports = __webpack_public_path__ + "img/695405811.42b04ad9.jpg";